import React from 'react'
import {Parallax, Carousel} from 'react-materialize'
import {AboutBox} from '../../components/AboutBox'
import {WhyCoding} from '../../components/WhyCoding'

class AboutMe extends React.Component {

  render() {
    return(
      <div className="container" style={{marginTop: 15}}>
        <div style={{height:50}}>
        <Parallax imageSrc="https://cdn.nimbusthemes.com/2017/09/09233341/Free-Nature-Backgrounds-Seaport-During-Daytime-by-Pexels.jpeg"/>
        </div>
        <div>
          <h1 className="header center red-text text-lighten-2" style={{fontFamily:'Leckerli One'}}>Derek Williams</h1>
          <div className="row center">
            <h5 className="header col s12 light">Full Stack Web Developer</h5>
          </div>
        </div>
        <div className="row" style={{marginTop:275}}>
          <div className="col s12 m4">
            <AboutBox icon="fas fa-user-graduate" title="Education" content="February 2019, I completed UNC's Full Stack Web Development Bootcamp through Trilogy Education. I also have a Bachelor's Degree in Psychology from the University of Tennessee."/>
          </div>

          <div className="col s12 m4">
            <AboutBox icon="fas fa-guitar" title="Hobbies" content="When I'm not coding, I'm either spending time with my kids (don't worry - pictures to follow), goofing around on the guitar, or hacking away on the golf course." />
          </div>

          <div className="col s12 m4">
            <AboutBox icon="fas fa-briefcase" title="Work" content="I currently work as a TA at Trilogy Education's Full Stack Web Development Bootcamp, and as a Senior Mortgage Consultant at NewRez LLC." />
          </div>
        </div>

        <div style={{marginTop: 15}}>
          <WhyCoding/>
        </div>
        <h2 className="center-align" style={{color:'#ccc'}}>As Promised...</h2>
        <Carousel images={[
          './images/library.jpg',
          './images/madison-pullen.jpg',
          './images/sweetheart-dance.jpg',
          './images/ballet.jpg',
          './images/george-park.jpg'
        ]} />
      </div>
    )
  }
}

export default AboutMe;